var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPastAnnouncements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1608 4V12.9604H20.0005C20.0005 12.9604 20.0005 16.9153 20.0005 18.1932C20.0005 19.4711 18.8102 19.9999 17.9285 19.9999C17.0467 19.9999 8.1686 19.9999 5.9201 19.9999C4.95012 19.9999 3.99994 19.0564 3.99994 18.0798C3.99994 17.3745 3.99994 4 3.99994 4H16.1608ZM17.9285 19.3601C18.327 19.3601 19.36 19.1506 19.36 18.1932V13.6002H16.1602V17.9171C16.1602 18.3457 16.7202 19.3601 17.6031 19.3601H17.9285ZM4.6404 18.0798C4.6404 18.7016 5.29826 19.3601 5.9207 19.3601H16.1926C15.7616 18.9111 15.5209 18.3211 15.5209 17.9171V4.63985H4.641L4.6404 18.0798Z",
    fill: "#081E56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2405 5.92017H5.92058V6.56002H14.2405V5.92017Z",
    fill: "#081E56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2405 14.5601H5.92058V15.1999H14.2405V14.5601Z",
    fill: "#081E56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2405 16.8002H5.92058V17.44H14.2405V16.8002Z",
    fill: "#081E56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92058 8.15967H14.2405V12.9598H5.92058V8.15967ZM6.56043 12.3199H13.6006V8.80012H6.56043V12.3199Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastAnnouncements);
export default __webpack_public_path__ + "static/media/PastAnnouncements.be4542fe8cf3ac3e8ef17bf35ffb0a5b.svg";
export { ForwardRef as ReactComponent };